import { createAction, props } from "@ngrx/store";
import { IUpgradePlanList } from "../../models/upgarde-plan.model";

export const loadUpgradePlanInfo = createAction(
    '[Plan] Load Upgrade Plan ',
        props<{ _sort:string}>()

);

export const loadUpgradePlanSuccess = createAction(
    '[Plan] Load Upgrade Plan Success',
    props<{ upgardePlanInfo: IUpgradePlanList }>()
);

export const loadUpgradePlanFailure = createAction(
    '[Plan] Load Upgrade Plan Failure',
    props<{ error: string }>()
);
